import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

/** `archived: true` archives the dossier, `false` restores it. */
class ChangeSubjectArchival {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly archived: boolean,
	) {
		Object.freeze(this);
	}
}

export default ChangeSubjectArchival;
